__turbopack_context__.v({
  "description-num": "MoveCard-module__b-a2fq__description-num",
  "element": "MoveCard-module__b-a2fq__element",
  "graph-content": "MoveCard-module__b-a2fq__graph-content",
  "info": "MoveCard-module__b-a2fq__info",
  "root": "MoveCard-module__b-a2fq__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
  "title": "MoveCard-module__b-a2fq__title",
});
